export default "__VITE_ASSET__BaQ3leWx__"